import clsx from 'clsx';

import { useDrawerInstance } from './hooks';
import { mergeSx } from '../../utils';
import { IconButton, IconButtonProps } from '../buttons';
import { CaretDoubleRight, X } from '../icons';

const styleMap = {
  absolute: {
    parent: { position: 'absolute', top: 26, left: 16 },
    child: { position: 'absolute', top: 16, right: 16 },
  },
  flex: {
    parent: { ml: -8 },
    child: { mr: -8, ml: 'auto' },
  },
} as const;

export type CloseDrawerButtonProps = IconButtonProps & {
  positioned?: 'absolute' | 'flex' | boolean;
  showGuard?: boolean;
};

export const CloseDrawerButton = ({
  positioned = 'absolute',
  showGuard,
  sx,
  ...props
}: CloseDrawerButtonProps) => {
  const drawerInstance = useDrawerInstance();
  const isChildDrawer = !!drawerInstance.parentId;

  const Icon = isChildDrawer ? X : CaretDoubleRight;

  positioned = positioned === true ? 'absolute' : positioned;
  const styles = positioned
    ? styleMap[positioned][isChildDrawer ? 'child' : 'parent']
    : undefined;

  return (
    <IconButton
      variant="ghost"
      size="sm"
      sx={mergeSx(styles, sx)}
      onClick={() => {
        if (showGuard) {
          drawerInstance.setShouldRenderGuard(true);
        } else {
          drawerInstance.close({ force: false });
        }
      }}
      testId="close-drawer"
      {...props}
      className={clsx(props.className, 'DS-CloseDrawerButton-root')}
    >
      <Icon />
    </IconButton>
  );
};
